export const TICK_RATE = 60;
export const DT = 1 / TICK_RATE;

// Arrow ballistics, shared by the sim (flight) and AI (aim solving).
export const ARROW_SPEED = 26;
export const ARROW_GRAVITY = 10;
/** Launch height above the shooter's feet. */
export const ARROW_LAUNCH_H = 1.5;
